














import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      titlePageChild: "Assign Request",
      subtitlePageChild: "Request list",
    };
  },
});
